export interface FluentFeatures {
  category: string;
  name: string;
  features: string[];
  futureFeatures?: string[];
  hidden?: boolean;
}

export const fluentFeatures: Record<string, FluentFeatures> = {
  routeSearch: {
    category: 'routing',
    name: 'Route planning',
    features: [
      'Fast A-B routing',
      'Air, Ocean & Road routing',
      'Detailed route itineraries',
      'Proforma schedules',
      'Service and flight details',
      'Carrier details',
    ],
  },
  advancedSearch: {
    category: 'routing',
    name: 'Advanced route search',
    features: ['Disruption avoidance', 'Canal avoidance', 'Aircraft filters', 'Cargo filters'],
  },
  schedules: {
    category: 'schedules',
    name: 'Schedule search',
    features: ['Ocean schedules', 'Air Cargo schedules', 'Forecast departures and arrivals'],
  },
  tracking: {
    category: 'tracking',
    name: 'Shipment Tracking',
    features: [
      'Usage based (additional fee per shipment)',
      'Container tracking',
      'AWB tracking',
      'Parcel tracking',
      'Live map updates & AIS location',
      'Email notifications',
      'Up-to-date ETAs',
      'Saved views & filters',
    ],
  },
  advancedTracking: {
    category: 'tracking',
    name: 'Advanced Shipment Tracking',
    features: [
      'Change logs',
      'Timeline view',
      'Advanced notifications',
      'Bulk upload',
      'High volume tracking',
      'MBOL and Booking num search',
      'Purchase order upload',
    ],
  },
  emissions: {
    category: 'emissions',
    name: 'CO2 Emissions',
    features: ['End-to-end emissions estimates', 'GLEC / Smart Freight certified'],
  },
  emissionsCalculator: {
    category: 'emissions',
    name: 'Emissions calculator & reports',
    features: ['Emissions calculator', 'Certified emissions reports', 'Air, Ocean, Rail and Road'],
  },
  rates: {
    category: 'rates',
    name: 'Rates & Booking',
    features: ['Market index rates integration'],
    futureFeatures: ['Spot rate search', 'Direct booking'],
  },
  rateManagement: {
    category: 'rates',
    name: 'Rates management',
    features: ['Rates dashboard'],
    futureFeatures: ['Contract rate management'],
  },
  insights: {
    category: 'insights',
    name: 'Insights',
    features: ['Shipping data and insights', 'Port Insights', 'Vessel Insights'],
  },
  vesselFinder: {
    category: 'vesselFinder',
    name: 'Vessel Tracker',
    features: ['View vessel details', 'Search vessels by name, IMO', 'See historic milestones + future schedules'],
    futureFeatures: ['Track vessels in real-time', 'Vessel position history'],
  },
  api: {
    category: 'api',
    name: 'API access',
    features: ['Routing API', 'Schedules API', 'Tracking API', 'Emissions API', 'Location Geocoder', 'Carrier API'],
  },
  support: {
    category: 'support',
    name: 'Support',
    features: ['General / email support'],
  },
  prioritySupport: {
    category: 'support',
    name: 'Priority Support',
    features: ['Dedicated support', 'Priority response to enquiries'],
  },
  whiteLabel: {
    category: 'whitelabel',
    name: 'Custom branding',
    features: ['Add your own logo when sharing externally'],
  },
  booking: {
    category: 'booking',
    name: 'Shipment booking',
    features: ['Book and manage shipments directly with your preferred carrier'],
    hidden: true,
  },
  history: {
    category: 'history',
    name: 'Search history',
    features: ['Access and manage search history'],
    hidden: true,
  },
  routeDetails: {
    category: 'routing',
    name: 'Route details',
    features: ['See full route details'],
    hidden: true,
  },
  savedItems: {
    category: 'savedItems',
    name: 'Saved Items',
    features: ['Bookmark routes, schedules, shipments'],
    hidden: true,
  },
  aiAssistant: {
    category: 'ai',
    name: 'AI Assistant',
    features: ['AI powered route & schedule search', 'AI powered shipment tracking'],
    hidden: true,
  },
  alerts: {
    category: 'alerts',
    name: 'Disruption Alerts',
    features: ['Real-time port disruptions', 'Delay severity indicators', 'Interactive map visualization'],
    hidden: false,
  },
};
